import axios from "axios";
export const googleMapsApi = axios.create({
  baseURL: process.env.VUE_APP_GOOGLE_MAPS_BASE_URL,
  params: {
    key: "AIzaSyCGVe7zxBnM9GNZ4EEd-Kz2yqjcadHjwmY",
  },
});
